import React from 'react';
import TextFieldForElements from '../TextFieldForElements';

class ElementsDimensionHeight extends React.Component {
  render() {
    const { shouldUpdateWithDiff } = this.props;
    return (
      <TextFieldForElements
        property="height"
        formattedMessage="properties.dimension.height"
        shouldUpdateWithDiff={shouldUpdateWithDiff}
      />
    );
  }
}

export default ElementsDimensionHeight;
